import Vue from 'vue'
import './axios';
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import { notificationManager } from '@/utils/notifications'

Vue.config.productionTip = false

// Inicializar el tema al cargar la aplicación
const savedTheme = localStorage.getItem('theme') || 'light'
document.documentElement.setAttribute('data-theme', savedTheme)

// Inicializar notificaciones
notificationManager.init().then(() => {
  console.log('Gestor de notificaciones inicializado');
}).catch(error => {
  console.warn('Error inicializando notificaciones:', error);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
